import { InputHTMLAttributes, useRef, useState } from "react";

type PasswordFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type">;

function VisibilityIcon({ visible }: { visible: boolean }) {
  return visible ? (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 3l18 18M10.6 10.7a2 2 0 002.7 2.7M9.9 4.2A10.8 10.8 0 0112 4c5.5 0 9 5.2 9 5.2a13.7 13.7 0 01-2.2 2.6M6.6 6.6C4.3 8 3 10 3 10s3.5 5 9 5c1 0 2-.2 2.9-.5" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 10s3.5-5 9-5 9 5 9 5-3.5 5-9 5-9-5-9-5z" />
      <circle cx="12" cy="10" r="2.5" />
    </svg>
  );
}

export function PasswordField(props: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const restoreInputFocus = useRef(false);
  const action = visible ? "Ocultar senha" : "Mostrar senha";

  return (
    <span className="password-input">
      <input {...props} ref={inputRef} type={visible ? "text" : "password"} />
      <button
        type="button"
        className="password-visibility"
        aria-label={action}
        aria-pressed={visible}
        title={action}
        onPointerDown={() => {
          restoreInputFocus.current = document.activeElement === inputRef.current;
        }}
        onClick={() => {
          setVisible((current) => !current);
          if (restoreInputFocus.current) requestAnimationFrame(() => inputRef.current?.focus({ preventScroll: true }));
        }}
      >
        <VisibilityIcon visible={visible} />
      </button>
    </span>
  );
}
